import img1 from "../../../../assets/images/examples/mediatheque/big.png";
import img2 from "../../../../assets/images/univs/archi_inter.jpg";
import img3 from "../../../../assets/images/univs/archi_outer.webp";
import img4 from "../../../../assets/images/univs/buiss_inter.jpg";
import img5 from "../../../../assets/images/univs/buiss_outer.webp";
import img6 from "../../../../assets/images/univs/design_inter.jpg";
import img7 from "../../../../assets/images/univs/design_outer.webp";
import img8 from "../../../../assets/images/univs/infou_inter.jpg";
import img9 from "../../../../assets/images/univs/infou_outer.jpg";
import img10 from "../../../../assets/images/univs/droit_inter.jpg";
import img11 from "../../../../assets/images/univs/droit_outer.webp";
import img12 from "../../../../assets/images/events/e3-2.jpg";

export const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
];
